export const ACTION_LABEL = {
  read: "View", create: "Create", update: "Edit", assign: "Assign", approve: "Approve", delete: "Delete / Archive",
  copy: "Copy", export: "Download / Export", print: "Print", import: "Import", share: "Share",
  manage_users: "Manage Users", manage_access: "Manage Access", view_audit: "View Audit Logs",
};
export const SCOPE_LABEL = {
  own: "Assigned to them", team: "Their team", branch: "Their branch(es)", new_business: "New business + assigned",
  repeat_business: "Repeat business + assigned", all: "All branches",
};
const MODULE_LABEL = { sales: "Sales & Leads", orders: "Orders / UIDs", operations: "Operations", bp: "Business Plan", dashboard: "Dashboards", hr: "Employee Records", admin: "Administration" };

export const PermEditor = ({ catalog, value, onChange, testid = "perm-editor" }) => {
  const mods = value.modules || {};
  const fields = value.fields || {};
  const setMod = (m, v) => onChange({ ...value, modules: { ...mods, [m]: v } });
  const toggle = (m, a) => {
    const cur = mods[m] || { actions: [], scope: "own" };
    const actions = cur.actions.includes(a) ? cur.actions.filter((x) => x !== a) : [...cur.actions, a];
    setMod(m, { ...cur, actions });
  };
  return (
    <div data-testid={testid} className="min-w-0 max-w-full">
      <div className="ax-label mb-2">Rights per module (tick to turn on) and which records they cover</div>
      <div className="overflow-x-auto border mb-4 max-w-full ax-freeze" style={{ maxWidth: "calc(100vw - 6rem)" }}>
        <table className="ax-table w-full min-w-[1100px]">
          <thead><tr><th>Module</th>{catalog.actions.map((a) => <th key={a} className="text-[11px] whitespace-nowrap">{ACTION_LABEL[a] || a}</th>)}<th>Records</th></tr></thead>
          <tbody>{catalog.modules.map((m) => (
            <tr key={m}>
              <td className="font-medium whitespace-nowrap">{MODULE_LABEL[m] || m}</td>
              {catalog.actions.map((a) => (
                <td key={a} className="text-center"><input type="checkbox" data-testid={`${testid}-${m}-${a}`} checked={!!mods[m]?.actions?.includes(a)} onChange={() => toggle(m, a)} /></td>
              ))}
              <td>
                <select data-testid={`${testid}-${m}-scope`} value={mods[m]?.scope || ""} onChange={(e) => setMod(m, { actions: mods[m]?.actions || [], scope: e.target.value })} className="bg-muted/60 border h-7 px-1 text-xs">
                  <option value="">—</option>{catalog.scopes.map((s) => <option key={s} value={s}>{SCOPE_LABEL[s] || s}</option>)}
                </select>
              </td>
            </tr>
          ))}</tbody>
        </table>
      </div>
      <div className="ax-label mb-2">Sensitive fields (default: no access)</div>
      <div className="grid sm:grid-cols-2 gap-2">
        {Object.entries(catalog.sensitive_fields).map(([k, label]) => (
          <label key={k} className="flex items-center justify-between border px-3 py-2 text-sm gap-2">
            <span>{label} <span className="font-mono text-[10px] text-muted-foreground">{k}</span></span>
            <select data-testid={`${testid}-field-${k}`} value={fields[k] || "none"} onChange={(e) => onChange({ ...value, fields: { ...fields, [k]: e.target.value } })} className="bg-muted/60 border h-7 px-1 text-xs">
              {catalog.field_levels.map((l) => <option key={l} value={l}>{l}</option>)}
            </select>
          </label>
        ))}
      </div>
    </div>
  );
};
